import { gql } from 'react-apollo';

export const updateRevival = gql`
  mutation updateRevival($input: UpdateRevivalInput!) {
    updateRevival(input: $input) {
      revival {
        church_id
        title
        image {
          default
        }
        preparationStartDate: preparation_start_date
        startDate: start_date
        endDate: end_date
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/revivals/mutations/updateRevival.js